/**
 * @file main App
 * @module app.main
 */

import { defineCustomElement } from '@/customElement'
import { META } from '@/configs/app.config'
import Root from '@/layout/index.vue'
customElements.define(META.appName, defineCustomElement(Root))
